import React, { useState, useEffect } from 'react';
import { FileText, X } from 'lucide-react';
import { Button } from './ui/button';

export const FloatingEstimateButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show button after scrolling 300px
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  if (!isVisible || isMinimized) {
    return null;
  }

  return (
    <div className="fixed bottom-8 right-8 z-50 animate-in slide-in-from-bottom-4 duration-500">
      <div className="relative">
        <Button
          onClick={scrollToContact}
          className="bg-gradient-to-r from-amber-600 to-amber-700 hover:from-amber-700 hover:to-amber-800 text-white px-8 py-6 text-lg font-bold shadow-2xl hover:shadow-3xl transition-all duration-300 rounded-full"
          size="lg"
        >
          <FileText className="mr-2 h-6 w-6" />
          Get FREE Estimate
        </Button>
        <button
          onClick={() => setIsMinimized(true)}
          className="absolute -top-2 -right-2 bg-slate-900 text-white rounded-full p-1 hover:bg-slate-800 transition-colors"
          aria-label="Minimize"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default FloatingEstimateButton;
